import { render, staticRenderFns } from "./ProductClassify.vue?vue&type=template&id=79972e00&scoped=true"
import script from "./ProductClassify.vue?vue&type=script&lang=js"
export * from "./ProductClassify.vue?vue&type=script&lang=js"
import style0 from "./ProductClassify.vue?vue&type=style&index=0&id=79972e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79972e00",
  null
  
)

export default component.exports